import type { ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import type { ColorScheme } from "@purpur/theme";

export const TitleHyphenVariant = {
  default: "default",
  enabled: "enabled",
  disabled: "disabled",
} as const;

export type TitleHyphens = (typeof TitleHyphenVariant)[keyof typeof TitleHyphenVariant];

export type HeroBannerProps = BaseProps & {
  /**
   * Custom content slot
   * Add your CTAs here with <HeroBanner.CTAs> component
   */
  children?: ReactNode;
  /**
   * Breadcrumbs: <br/>
   *  - Slot for your Breadcrumbs component
   */
  breadcrumbs?: ReactNode;
  forceColorScheme?: ColorScheme;
  /**
   * Content to display before the main heading
   */
  beforeTitle?: ReactNode;
  /**
   * Main heading of the component
   */
  title: string;
  /**
   * Main heading tag
   */
  headingTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  titleHyphens?: TitleHyphens;
  /**
   * Preamble text
   */
  preamble?: string;
  /**
   * Additional text under the CTAs, recommended to limit element to simple text with text decorations
   */
  additionalText?: ReactNode;
  /**
   * <HeroBanner.Media /> component (images and videos)
   */
  media?: ReactNode;
};
